import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';

import { EnrolmentStorageInterface } from '../definitions/enrolment-storage.interface';
import { environment } from '../environments/environment';
import { CustomerModuleKey } from '../models/customer';
import { getStorageObject } from '../utils/storage-manager';
import { CourseService } from './course.service';
import { CustomerService } from './customer.service';

export const courseDetailGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const courseService = inject(CourseService);
  const customerService = inject(CustomerService);

  try {
    if (localStorage.getItem('test_mode') && environment.name !== 'prod') {
      return true;
    }

    if (customerService.isCustomerModuleEnabled(CustomerModuleKey.HIDE_COURSE_CATALOG)) {
      return router.parseUrl('overview');
    }

    const courseId = route.paramMap.get('id');
    const course = await lastValueFrom(courseService.getCourseById(Number(courseId)));
    const userEnrolments: EnrolmentStorageInterface[] = getStorageObject(environment.userEnrolmentStorage) ?? [];
    const isEnrolled = userEnrolments.some((e) => e.code === course.code);

    if (
      !course.isFree() &&
      customerService.isCustomerModuleEnabled(CustomerModuleKey.VERTICAL_SOON_TO_BE_CLOSED) &&
      !isEnrolled
    ) {
      return router.parseUrl('no-permission-content');
    }

    if (course.isActive) {
      if (customerService.isCustomerModuleEnabled(CustomerModuleKey.ONLYFREECOURSESWEB)) {
        return course.isFree();
      }

      return true;
    } else {
      return await lastValueFrom(courseService.isEnrolled(course._id));
    }
  } catch {
    return router.parseUrl('overview');
  }
};
